module.exports = __webpack_public_path__ + "img/postnord.38365bc4.svg";